import React, { useEffect } from "react";
import { useCookies } from "react-cookie";
import { useHistory } from "react-router-dom";
import Navbar from "../../components/layout/Navbar";

/**
 * React component for user sign-out.
 * @returns {JSX.Element}
 * @constructor
 */
export default function SignOut() {
    const history = useHistory();
    const [cookies, , removeCookie] = useCookies();

    // Rensa alla cookies när komponenten laddas
    useEffect(() => {
        Object.keys(cookies).forEach((cookieName) => {
            removeCookie(cookieName, { path: "/" });
        });
    }, [cookies, removeCookie]);

    function onClick() {
        history.push("/");
    }

    return (
        <div className="min-h-screen bg-sage font-body pt-16">
            
            <Navbar />

            <div className="flex items-center justify-center min-h-[calc(100vh-4rem)] p-4">
                <div className="w-full md:max-w-md bg-offwhite md:shadow-lg md:rounded-lg overflow-hidden">
                
                {/* Content Section */}
                <div className="w-full bg-offwhite flex items-center justify-center">
                    <div className="w-full max-w-md px-6 py-8">
                        <div className="flex flex-col items-center">
                            {/* Lock Icon */}
                            <div className="flex items-center justify-center w-10 h-10 rounded-full bg-forest mb-4">
                                <svg className="w-6 h-6 text-offwhite" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                                </svg>
                            </div>
                            
                            <h1 className="text-2xl font-heading font-semibold text-charcoal mb-4">
                                Du är utloggad
                            </h1>
                            
                            <p className="text-brown text-center mb-6">
                                Klicka på knappen nedan för att gå tillbaka till startsidan.
                            </p>
                            
                            <button
                                onClick={onClick}
                                className="w-full bg-leaf text-offwhite py-2 px-4 rounded-md hover:bg-forest transition-colors duration-200 mb-4 font-medium"
                            >
                                Till startsidan
                            </button>

                            {/* Footer */}
                            <div className="mt-8 pt-8 text-center w-full border-t border-sage">
                                <p className="text-sm text-brown">
                                    &copy; {new Date().getFullYear()} Naturborgarmärket
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            </div>
        </div>
    );
}
